import React from "react";
import { Container, Row, Col, Button } from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import Editor from "../../components/add-new-post/TaskEditor";
import SidebarActions from "../../components/add-new-post/SidebarActions";
import SidebarCategories from "../../components/add-new-post/SidebarCategories";

const AddNewTask = () => (
  <Container fluid className="main-content-container px-4 pb-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Add New Task" subtitle="New target to finish" className="text-sm-left" />
    </Row>
    <Row>
      {/* Editor */}
      <Col lg="12" md="12">
        <Editor placeholder={"Your Task Title"}/>
      </Col>
      {/* Sidebar Widgets */}
      {/* <Col lg="3" md="12">
        <SidebarActions />
        <SidebarCategories />
      </Col> */}
    </Row>
  </Container>
);

export default AddNewTask;